import * as React from "react";
import PopDetail from "../popdetail";
import Wait from "../wait";
import CreateService from "../../service/create";

export default class PaneAddLocalityInfo extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            registration:'',
            address:'',
            total:0
        }

        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
    }

    handleChanges=(e)=>{this.setState({[e.target.name]:e.target.value})}


    render() {
        return(<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding:0}}>

                <h2 style={{marginLeft:'28px'}}>{this.props.locality.name}</h2>
                <table style={{width:'94%',margin:'2%'}}>
                    <tbody>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Registration Number</td>
                    </tr>
                    <tr>
                         <td>
                             <input  style={{width:'100%'}}  name={'registration'} onChange={this.handleChanges}/>
                         </td>
                    </tr>
                     <tr>
                         <td  style={{width:'100%'}}><span className={'label'}>Total Registered CCRO</span> ( Before this Project )</td>
                    </tr>
                    <tr>
                         <td>
                             <input type={'number'} style={{width:'100%'}}  name={'total'} onChange={this.handleChanges}/>
                         </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Address ( P.O Box )</td>
                    </tr>
                    <tr>
                         <td>
                             <b>S.L.P</b> <input  style={{width:'60%'}}  name={'address'} onChange={this.handleChanges} placeholder={'445, Mbeya'}/>
                         </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{textAlign:'center',width:'100%',float:'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Submit
                    </button>
                     <button className={'btn error'} onClick={()=>PopDetail.dismiss()}>
                        <span className={'fa fa-times'} style={{padding:0}}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }


    submit(){
        try{

            let registration = this.state.registration
            let address = this.state.address

            Wait.show('Updating...')
            CreateService.updateLocalitiesCode({
                project_id:this.props.project.id,
                locality_id: this.props.locality.id,
                task_id:this.props.taskId,
                screen_code:this.props.screen_code,
                registration:registration,
                address:address,
                total:this.state.total
            }).then(d=>{
                Wait.dismiss()
                /*if (d.data.status===0){
                    alert(d.data.message)
                    return
                }*/
                this.props.loadData()
                PopDetail.dismiss()
            })




        }catch (e) {
             alert(e)
        }
    }


}